export default "__VITE_ASSET__Po8JRuM0__"